// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7W9dY","badges":"styles_badges__1weOh"};